module.exports = __webpack_public_path__ + "static/01_marker-corona_kulturelle-nutzung-01-325f55c1dc3665cab27ed1b93145782f.png";